<template>
  <div class="mask" v-show="show">
    <transition name="slide-fade">
      <div class="silder">
        <div class="header">
          <span
            class="iconfont iconnext actable"
            @click.prevent="$emit('close')"
          ></span>
          <span class="title">過往期刊</span>
          <span
            class="iconfont iconsearch actable"
            @click.prevent="navto('/search')"
          ></span>
        </div>
        <loading
          :active.sync="loading"
          :is-full-page="false"
          loader="dots"
          color="#00ab00"
        ></loading>
        <div id="mags" class="mags vld-parent">
          <div
            v-for="isu in issues"
            :key="isu.issueId"
            class="sildercard actable"
            @click.prevent="navto(`/mag/${brandCode}/${isu.issueId}`)"
          >
            <image-loader class="sildercover" :src="isu.cover" />
            <div class="silderbottombar">
              <span>{{ isu.issueNo }}</span>
              <span>期</span>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { get } from "../libs/request";
import { API } from "../libs/consts";

export default {
  name: "Silder",
  props: ["brandCode", "show"],
  data() {
    return {
      pgInd: 1,
      pgLen: 15,
      totalpage: 1,
      issues: [],
      title: "",
      loading: false,
    };
  },
  methods: {
    loadData() {
      if (this.loading || this.pgInd > this.totalpage) {
        return;
      }
      const { pgInd, pgLen, brandCode } = this;
      this.loading = true;
      get(API.magz.brand.oldmags(brandCode), { pgInd, pgLen, brandCode })
        .then((rps) => {
          if (rps.errMsg == API.Code.ok) {
            this.pgInd++;
            this.issues.push(...rps.data.list);
            this.title = rps.data.magzName;
            this.totalpage = rps.data.pageTotal;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    navto(link) {
      this.$router.push(link);
      this.$emit("close");
    },
    scroll() {
      const ele = document.querySelector("#mags");
      if ((ele.clientHeight + ele.scrollTop) / ele.scrollHeight > 0.98) {
        this.loadData();
      }
    },
  },
  watch: {
    show(newval) {
      const ele = document.querySelector("#mags");
      if (newval) {
        document.body.style["overflowY"] = "hidden";
        ele.addEventListener("scroll", this.scroll);
        this.loadData();
      } else {
        document.body.style["overflowY"] = "auto";
        ele.removeEventListener("scroll", this.scroll);
      }
    },
  },
};
</script>

<style scoped>
.silder {
  position: fixed;
  right: 0;
  top: 0;
  width: 14.82rem;
  height: 100vh;
  background-color: #fff;
}

.header {
  height: 0.8rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #474747;
  padding: 0 0.2rem;
}

.header span {
  /* fix ie display diff */
  display: inline-block;
}

.iconfont {
  font-size: 0.24rem;
  color: #777777;
}

.title {
  width: 2.83rem;
  border-bottom: 1px solid #474747;
  font-size: 0.22rem;
  height: 0.8rem;
  line-height: 0.8rem;
  text-align: center;
}

.slide-fade-enter-active {
  transition: width 0.3s ease-in;
}
.slide-fade-leave-active {
  width: 0;
  transition: width 0.3s ease-out;
  /* cubic-bezier(1, 0.5, 0.8, 1); */
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  /* opacity: 0; */
}

.mags {
  position: relative;
  display: flex;
  padding: 0.2rem;
  flex-wrap: wrap;
  overflow-y: auto;
  height: calc(100vh - 0.8rem);
}

.sildercard {
  width: 2.28rem;
  height: 3.54rem;
  box-shadow: 0px 0px 10px 0px rgba(132, 132, 132, 0.5);
  margin: 0.2rem;
}

.sildercover {
  width: 2.28rem;
  height: 3.14rem;
}

.silderbottombar {
  font-size: 0.22rem;
  color: #474747;
  padding: 0 0.15rem;
  display: flex;
  justify-content: space-between;
}

.mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(132, 132, 132, 0.5);
  z-index: 12;
}
</style>